<template>
  <el-popover
    popper-class="el-popover-clearstyle-class"
    :visible-arrow="false"
    trigger="click"
    placement="bottom-end"
    ref="elPopover"
    :offset="120"
    v-model="visible"
  >
    <div class="login-verify-tips" ref="popoverContainer">
      <div class="close-btn" @click="close">
        <SvgIcon iconClass="circle-close" />
      </div>
      <span v-if="!isLogined">实名登录，高清无遮挡</span>
      <span v-if="isLogined && !isVerifyed">
        去<span style="color: #019FDA;" @click="openVerify">实名</span>，高清无遮挡
      </span>
    </div>
  </el-popover>
</template>

<script>
import eventBus from "@/plugins/eventBus";
import { debounce } from "@/plugins/util";

export default {
  name: "LoginVerifyTips",
  data() {
    return {
      visible: false,
      referenceElm: null,
      closeTimer: null
    };
  },
  computed: {
    // 是否已登录
    isLogined() {
      return !!(this.loginUser && this.loginUser.uid);
    },
    // 是否已认证
    isVerifyed() {
      return this.isLogined && this.loginUser.verify_level === 2;
    },
    // 是否成人
    isAdulted() {
      return this.isVerifyed && this.loginUser.adulthood;
    }
  },
  mounted() {
    // 监听未成年登录认证实名事件
    eventBus.$on("onShowLoginVerifyTips", () => {
      // 未登录或未认证的用户显示提示
      if ((!this.isLogined || !this.isVerifyed) && !this.loginUser.is_super) {
        this.open();
      }
      // 5s后自动关闭
      this.closeTimer = setTimeout(() => {
        this.close();
      }, 5 * 1000);
    });

    window.addEventListener("mousedown", this.checkOtherArea);
  },
  beforeDestory() {
    window.removeEventListener("mousedown", this.checkOtherArea);
  },

  methods: {
    // 打开实名认证
    openVerify() {
      this.visible = false;
      eventBus.$emit("onShowAuthRealName");
    },
    // 检查是否点击其他区域
    checkOtherArea: debounce(function(e) {
      const target = e.target;
      const containerEl = this.$refs && this.$refs.popoverContainer;
      if (this.referenceElm && this.referenceElm.contains(target)) return;
      if (!(containerEl && containerEl.parentNode.contains(target))) {
        this.close();
      }
    }, 200),
    open() {
      const referenceElm = document.querySelector("#__login_verify_tips_ref__");
      if (referenceElm) {
        this.$refs.elPopover.referenceElm = referenceElm;
        this.referenceElm = referenceElm;
        this.visible = true;
      }
    },
    close() {
      this.visible = false;
      this.$refs.elPopover.referenceElm = null;
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
      }
      this.closeTimer = null;
    }
  }
};
</script>

<style lang="less">
.login-verify-tips {
  position: relative;
  width: 245px;
  height: 91px;
  padding: 60px 88px 14px 27px;
  background: url("~@/assets/images/login-verify-tips-bg.png") no-repeat;
  background-size: 100% 100%;
  font-weight: bold;
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  margin-top: 0;

  .close-btn {
    position: absolute;
    top: 26px;
    right: -10px;
    width: 20px;
    height: 20px;
    font-size: 20px;
    color: #000;
    cursor: pointer;
  }
}
</style>
